import {
  ResponsiveContainer,
  LineChart,
  Line,
  CartesianGrid,
  XAxis,
  YAxis,
  ReferenceLine,
} from "recharts";
import { LIMIT_LOW, LIMIT_HIGH, IDEAL_LOW, IDEAL_HIGH } from "../utils";

type DataPoint = {
  idx: number;
  leitura: number;
};

type MiniChartProps = {
  data?: DataPoint[];
  compact?: boolean;
  showValues?: boolean;
};

export default function MiniChart({
  data = [],
  compact = false,
  showValues = false,
}: MiniChartProps) {
  const margin = compact
    ? { top: 6, right: 10, bottom: showValues ? 24 : 0, left: 10 }
    : { top: 12, right: 14, bottom: showValues ? 28 : 12, left: 14 };

  const fmtTick = (v: number) => {
    const p = (data || [])[v - 1];
    const n = p?.leitura;
    return n == null ? "" : `${Number(n).toFixed(1)}g`;
  };

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart data={data} margin={margin}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis
          dataKey="idx"
          hide={!showValues}
          tickFormatter={fmtTick}
          interval={0}
          minTickGap={0}
          tickLine={false}
          axisLine={false}
          // >>> padding lateral para não cortar 1º/último
          padding={{ left: 16, right: 16 }}
          // >>> fonte maior e mais legível
          tick={{ fontSize: 12, fontWeight: 600 }}
          // dá um respiro vertical
          tickMargin={6}
          dy={4}
        />

        <YAxis domain={[LIMIT_LOW - 1, LIMIT_HIGH + 2]} />

        <ReferenceLine y={IDEAL_HIGH} stroke="red" strokeWidth={1} />
        <ReferenceLine y={IDEAL_LOW} stroke="green" strokeWidth={3} />
        <ReferenceLine y={LIMIT_LOW} stroke="red" strokeWidth={2} />

        <Line
          type="monotone"
          dataKey="leitura"
          dot={false}
          stroke="blue"
          strokeWidth={2}
        />
      </LineChart>
    </ResponsiveContainer>
  );
}
// <ReferenceLine y={LIMIT_HIGH} stroke="red" strokeWidth={1}/>